import {LinkTarget} from "./link-target";
import type {GimmickName} from "../../gimmicks/gimmick-registry";

/**
 * A tile that carries a gimmick instead of linking somewhere (feature plans 0071, 0072, 0073) — the stopwatch,
 * the picker or the timer.
 * Stored as `{kind: 'gimmick', gimmick: 'stopwatch', options: {skin: 'ring'}}` in the tile's free `target`
 * JSON; the backend does not look inside it.
 *
 * `options` is free per gimmick and kept as it came, keys this version does not know included, so a later
 * gimmick setting survives a save in an older tab. Its values are read through the registry
 * (`resolveSkin(gimmick, raw)`), never trusted raw.
 */
export class GimmickLinkTarget extends LinkTarget {

    public readonly kind = 'gimmick' as const;

    public constructor(
        public readonly gimmick: GimmickName,
        public readonly options: Readonly<Record<string, unknown>> = {},
    ) {
        super();
    }

    public toJSON(): Record<string, unknown> {
        return {kind: this.kind, gimmick: this.gimmick, options: {...this.options}};
    }

}
